import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { Icon } from '@uncinc/uncinc-react-kitchen-sink';

import Card from '../../../Card';

import './style.scss';

export interface SearchAllContentPageHitProps {
  contentType: string;
  articleType?: string;
  link?: string;
  title: string;
  subtitle?: string;
  image?: React.ReactNode;
  hideTag?: boolean;
}

const SearchAllContentPageHit: React.FC<SearchAllContentPageHitProps> = (props) => {
  const {
    contentType,
    articleType,
    link,
    title,
    subtitle,
    image,
    hideTag,
  } = props;

  const { t } = useTranslation();

  const classes = c('SearchAllContent__PageHit', `SearchAllContent__PageHit--${contentType}`);

  return (
    <Card className={classes} {...link && { withLink: true }}>
      {link ? (
        <Card.Link href={link}>
          <Card.Title title={title} />
          {contentType === 'vacancy' && <Icon name="arrow_outward" flair="outlined" />}
        </Card.Link>
      ) : (
        <Card.Title title={title} />
      )}

      <Card.Content>
        <Card.Subtitle
          className="u-truncate--3"
          subtitle={(
            <>
              {!hideTag && (
                <Card.Tags
                  tags={[{
                    type: 'content_type',
                    name: articleType || t(`content_types.${contentType}.type`),
                  }]}
                />
              )}

              <p className="body--small">
                {subtitle}
              </p>
            </>
          )}
        />

        {image && (
          <Card.Image image={image} />
        )}
      </Card.Content>
    </Card>
  );
};

export default SearchAllContentPageHit;
